// extracted by mini-css-extract-plugin
export default {"root":"ListingRating_root__4FwL-","star":"ListingRating_star__l8V5K","text":"ListingRating_text__PA4am"};